
<template lang="pug">
y-dialog(v-model="dialog" width="600px" persistent scrollable)
  v-card
    v-card-title.px-4.py-2
      h6 {{ $t('add_card') }}
      v-spacer
      v-btn(icon @click="dialog = false")
        v-icon mdi-close
    v-card-text.px-4
      div.p2.basic600--text.my-3(v-html="$t('card_text')")
      v-form(ref="form")
        p.mb-1.label.basic600--text.text-uppercase {{ $t('name_on_card') }}
        v-text-field.p1.pt-2(dense solo flat background-color="basic200"    height="40" color="primary" outlined label="" v-model="name" :rules="rules.name")
          template(v-slot:label)
            .p1.basic600--text {{ $t('name_on_card') }}
        p.mb-1.label.basic600--text.text-uppercase {{ $t('card_number') }}
        v-stripe-card.pt-2(dense solo flat background-color="basic200"    height="40" v-if="dialog && stripeKey" ref="stripeCard" color="primary" @input="addCard($event)" @ready="cardReady" :api-key="stripeKey" outlined)
        p.c1.basic600--text(v-html="$t('description_1')")
        p.c1.basic600--text(v-html="$t('description_2')")
        p.c1.basic600--text(v-html="$t('description_3')")
        v-img.mt-4(v-if="cardMounted" :src="require('@/assets/images/powered_by_stripe.png')" contain max-height="30")
        v-img.mt-4(v-if="cardMounted" :src="require('@/assets/images/visa_mastercard_logo.png')" contain max-height="30")

    v-card-actions
      v-spacer
      v-btn(color='white', text @click='dialog = false')
            .button-Aa-medium.primary400--text {{ $t('cancel') }}
      v-btn.mr-2(color='textColorAccent' dark depressed height=32 @click="submit" :loading="loading")
        .button-AA-medium.basic100--text {{ $t('add_card') }}

</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import VStripeCard from 'v-stripe-elements/lib/VStripeCard'
export default {
  name: "CardInput",
  components: { VStripeCard },
  props: ['value'],
  data: () => ({
    loading: false,
    name: '',
    cardMounted: true,
    rules: {
      name: [
        v => !!v || 'Name is required'
      ]
    }
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    stripeKey () {
      if (this.company && this.company.stripe_account) {
        if (this.company.stripe_account === 'account_2') {
          return process.env.VUE_APP_STRIPE2_API_KEY
        } else {
          return process.env.VUE_APP_STRIPE_API_KEY
        }
      } else {
        return process.env.VUE_APP_STRIPE_API_KEY
      }
    },
    dialog: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    dialog () {
      this.name = ''
      this.loading = false
      this.$refs.form.reset()
    }
  },
  methods: {...mapActions([
      'showMessage'
    ]),
    cardReady () {
      this.$watch(
        () => this.$refs.stripeCard.errorBucket,
        (val) => {
          if (val.length > 0) {
            this.loading = false
          }
        }
      )
    },
    submit () {
      if (!this.$refs.form.validate()) {
        return
      }

      this.$refs.stripeCard.processCard()
    },
    addCard (token) {
      if (this.loading) {
        return
      }

      this.loading = true
      this.$axios.post('/billing/cards/', { name: this.name, token: token.id })
        .then(resp => {
          this.$emit('added', resp.data)
          this.dialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.error_adding_card')])
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "card_text": "Any credit card or debit card with <b>Mastercard</b> or <b>Visa</b> logo is accepted",
    "card_number": "Card Number / Exp date / CVV",
    "description_1": "Your card number will be securely transmitted and stored directly by our payment provider, Stripe. Yezza.io does not store your card number.",
    "description_2": "<b>We won't charge your card.</b> You may see a temporary pre-authorization charge to verify the card, which will be reversed within a week.",
    "description_3": "If your card is declined, please check with your bank that it has been enabled for online transaction."
  },
  "id": {
    "card_text": "Kartu kredit atau kartu debit apa pun dengan logo <b>Mastercard</b> atau <b>Visa</b> diterima",
    "card_number": "Nomor Kartu / Tanggal Kedaluwarsa / CVV",
    "description_1": "Nomor kartu kamu akan dikirim dan disimpan dengan aman langsung oleh penyedia pembayaran kami, Stripe. Yezza.io tidak menyimpan nomor kartu kamu.",
    "description_2": "<b>Kami tidak akan menagih kartu kamu.</b> kamu mungkin melihat tagihan pra-otorisasi sementara untuk memverifikasi kartu, yang akan dikembalikan dalam waktu seminggu.",
    "description_3": "Jika kartu kamu ditolak, harap tanyakan kepada bank kamu bahwa kartu tersebut telah diaktifkan untuk transaksi online."
  }
}
</i18n>